<template>
  <div class="about">
    <Navbar />
    <div class="about-title py-5 px-3">
      <h1 class="font-weight-bolder text-white pt-5 mt-5 kovatek-text">
        About Us
      </h1>
      <p class="font-weight-lighter text-white mb-5">
        Bridging the gap between jobs and talent
      </p>
    </div>
    <div
      class="container mx-auto about-content px-3 px-sm-4 px-md-5 my-5 text-left"
    >
      <h3
        class="blog-content-header font-weight-bolder kovatek-text text-center ctrl-header"
      >
        Changing the narrative
      </h3>
      <p class="blog-content-text mt-4">
        TalentAlt brings about technological innovation, the next great
        evolution for even distribution of talent.
      </p>
      <p class="blog-content-text">
        We are keen on pooling top software talents across the globe and serve
        as a channel to portray African talents to the global market. TalentAlt
        embraces a value oriented system and commitment to excellent service and
        we reflect this in our passion to deliver satisfactory services.
      </p>
      <h5
        class="blog-content-header font-weight-bolder mt-4 ctrl-title kovatek-text"
      >
        What Is Vital For Us?
      </h5>
      <p class="blog-content-text">
        From the best of the best, TalentAlt has the top 3-5% of African
        software talents, vetted, fit for the global market and placed in a
        learning environment that ensures growth and will continuously enable
        them stay relevant; this for us is important and is of essence.
      </p>
      <h5
        class="blog-content-header font-weight-bolder mt-4 ctrl-title kovatek-text"
      >
        What Is Our Vision?
      </h5>
      <p class="blog-content-text">
        To be the leading innovative technology for businesses and software
        talents to connect, collaborate and build software products.
      </p>
      <h5
        class="blog-content-header font-weight-bolder mt-4 ctrl-title kovatek-text"
      >
        What Is Our Mission?
      </h5>
      <p class="">To enable a talent driven system</p>
      <p class="">To enhance effective remote working culture</p>
      <p class="">To stimulate technology development</p>
      <p class="">To create an all-inclusive community for software talents</p>
      <h5
        class="blog-content-header font-weight-bolder mt-4 ctrl-title kovatek-text"
      >
        Our philosophy
      </h5>
      <p class=""><b>GIVE:</b> Growth, Innovation, Value, Excellence</p>
    </div>
    <GetHired />
    <Footer />
  </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import GetHired from '@/components/GetHired.vue';

export default {
  name: 'about',
  components: {
    Navbar,
    Footer,
    GetHired,
  },
};
</script>
<style scoped>
.kovatek-text {
  color: #20409a;
}
.about-title {
  background-color: #20409a;
}

@media screen and (max-width: 540px) {
  .ctrl-header {
    font-size: 20px;
  }
  .ctrl-title {
    font-size: 16px;
  }
}
</style>
